import React from "react";
import { Formik, Form } from "formik";
import { Grid, Button, Typography, Paper } from "@mui/material";
import * as Yup from "yup"; // Validation schema
import "./considered-areas.css";

// Risk data array
const risksData = [
  "Appropriate levels of staffing in connection to risks",
  "Staff training in Team Teach physical intervention and managing challenging behaviour.",
  "Staff trained in therapeutic parenting when completed all mandatory training",
  "Restorative approach",
  "Use of consequence and rewards",
  "Positive role modelling",
  "Consistent structure, rules and boundaries",
  "Monthly clinical consultation",
  "Access to direct and inGrididualised therapy sessions.",
  "Safe Environment",
  "Staff dynamics to meet her inGrididual needs",
  "Promoting inGrididual activities",
];

// Validation schema
const validationSchema = Yup.object().shape(
  risksData.reduce((acc, _, index) => {
    acc[`violence_staff_${index}`] = Yup.string().required("Risk level is required");
    return acc;
  }, {})
);

const ViolenceTowardsStafF = ({ updateFormData, nextStep, prevStep }) => {
  // Initial values setup for formik
  const initialValues = risksData.reduce((acc, _, index) => {
    acc[`violence_staff_${index}`] = "LOW"; // Default all risks to LOW
    return acc;
  }, {});

  // Calculate the risk percentage
  const calculateRiskPercentage = (values) => {
    const highRisks = Object.values(values).filter((risk) => risk === "HIGH").length;
    return Math.round((highRisks / risksData.length) * 100);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        // Send the risk values to the backend via updateFormData
        updateFormData({ violenceTowardsStaffInfo: values });
        nextStep(); // Move to the next step
      }}
    >
      {({ values, setFieldValue, handleSubmit }) => (
        <Form onSubmit={handleSubmit} className='risk-assessment-container'>
          <Typography variant='h6' sx={{ fontWeight: "bold" }} align='left'>
            Considered Areas Of Known Risk & Concern
          </Typography>
          <Typography variant='subtitle1' className='form-subtitle' gutterBottom align='left'>
            Explain the reasons why this young person is being considered for placement.
          </Typography>
          <Typography variant='subtitle1' sx={{ fontWeight: "bold" }} align='left'>
            Aggression & violence towards staff
          </Typography>
          <Typography variant='body2'>Select medium, high, low from the below risk levels.</Typography>

          {/* Render risksData dynamically */}
          <Grid className='risk-table' mt={2}>
            {risksData.map((risk, index) => (
              <Paper elevation={2} style={{ padding: "10px", marginBottom: "20px", backgroundColor: "#f5faff" }}>
                <Grid key={index} className='risk-row'>
                  <Grid className='risk-label'>{risk}</Grid>
                  <Grid className='risk-buttons'>
                    <button
                      type='button'
                      className={`risk-btn ${values[`violence_staff_${index}`] === "LOW" ? "low" : ""}`}
                      onClick={() => setFieldValue(`violence_staff_${index}`, "LOW")}
                    >
                      LOW
                    </button>
                    <button
                      type='button'
                      className={`risk-btn ${values[`violence_staff_${index}`] === "MEDIUM" ? "medium" : ""}`}
                      onClick={() => setFieldValue(`violence_staff_${index}`, "MEDIUM")}
                    >
                      MEDIUM
                    </button>
                    <button
                      type='button'
                      className={`risk-btn ${values[`violence_staff_${index}`] === "HIGH" ? "high" : ""}`}
                      onClick={() => setFieldValue(`violence_staff_${index}`, "HIGH")}
                    >
                      HIGH
                    </button>
                  </Grid>
                </Grid>
              </Paper>
            ))}
          </Grid>

          {/* Risk Level Percentage */}
          <Grid className='risk-percentage'>
            <Typography variant='h6' mb={-5}>
              Risk Level
            </Typography>
            {calculateRiskPercentage(values) <= 40 ? (
              <p className='risk-level-low'>{calculateRiskPercentage(values)}%</p>
            ) : calculateRiskPercentage(values) <= 60 ? (
              <p className='risk-level-medium'>{calculateRiskPercentage(values)}%</p>
            ) : (
              <p className='risk-level-high'>{calculateRiskPercentage(values)}%</p>
            )}
          </Grid>
          {/* Submit and Navigation Buttons */}
          <Grid container justifyContent='space-between' alignItems='center'>
            <Grid item>
              <Button type='button' variant='contained' color='primary' onClick={prevStep}>
                Previous
              </Button>
            </Grid>
            <Grid item>
              <Button type='submit' variant='contained' color='primary'>
                Next
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default ViolenceTowardsStafF;
